import { css } from '@emotion/react'
import theme from '../../../styles/theme'
import styled from '@emotion/styled'

/* Generic Panel Styles - These are shared across multiple components */
export const PanelStyles = css`
  padding: 1.7rem;
  margin-bottom: 0.8rem;
  margin-top: 0.8rem;
  border-radius: 1.1rem;
  background-color: ${theme.colors.surface};
`

export const SecondaryPanelStyles = css`
  ${PanelStyles}
  //transparent background
  background-color: rgba(0, 0, 0, 0);
`

/* Base Accordion Styles - Internal building blocks shared by all accordions */
export const baseAccordionContainer = css`
  display: flex;
  flex-direction: column;
  border: none;
`

export const baseAccordionHeader = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Panel = styled.div`
  ${PanelStyles}
  box-shadow: ${theme.shadows.light};
  background-color: ${theme.colors.surface};
`

export const PanelSecondary = styled.div`
  ${SecondaryPanelStyles}
`
